import { Collapse } from 'antd'
import { Trans, useTranslation } from 'react-i18next';

const { Panel } = Collapse;

export default function TermsOfUse() {
    const { t } = useTranslation("termsOfUse");

    return (
        <Collapse>
            <Panel header={t("otsikko")} key={1} style={{ whiteSpace: "normal" }}>
                <div>
                    <Trans i18nKey={"termsOfUse:ekaLause"}>
                        Tietojen tallennuspaikka on EU (Hollanti). Tiedot säilytetään salatussa muodossa palveluntarjoajan (Microsoft) toimesta.
                        Lisäksi sähköpostiosoite on kryptattu erikseen. <b>Palvelun ylläpitäjä voi nähdä tallennetun sähköpostiosoitteen selkokielisenä esimerkiksi ylläpitotoimenpiteiden yhteydessä,
                            mutta tallennettuja sähköpostiosoitteita ei kukaan käy aktiivisesti tarkastelemassa.</b>
                    </Trans>
                </div>
                <br />
                <div>
                    {t("aktivaatioHomma")}
                </div>
                <br />
                <div>
                    <Trans i18nKey={"termsOfUse:sendgrid"}>
                        Sähköpostien lähettämiseen käytetään SendGrid-palvelua, jonka kattavan tietoturvaselosteen löydät <a style={{ color: "blue" }} target="blank" href="https://sendgrid.com/policies/security/">täältä</a> (vain englanniksi).
                        SendGrid säilyttää tietoja (kuten saajan osoitteen selkokielisenä) 30 päivän ajan.
                    </Trans>
                </div>
                <br />
                <div>
                    {t("eiUlkopuolisille")}
                </div>
                <br />
            </Panel>
        </Collapse >
    )
}